<template>
    <vx-card>
        <div class="flex justify-end mb-6">
            <vs-button v-if="!isEdit" @click="$router.go(-1)" color="danger" type="filled" icon-pack="feather" icon="icon-x" class="mr-4">Cancel</vs-button>
            
            <vs-button v-if="isEdit" color="primary" type="filled" @click="$router.push({name:'org_management_sites'})">Done</vs-button>
            <vs-button v-else color="primary" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="saveForm()">Save</vs-button>
        </div>

        <ag-grid-vue
          ref="agGridTable"
          style="height: 450px"
          class="ag-theme-alpine mb-4"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="lists"
          :animateRows="true"
          :paginationAutoPageSize="true"
          :pagination="true"
          @grid-ready="onGridReady">
        </ag-grid-vue>

        <!-- <vs-table stripe :data="lists">
            <template slot="thead">
                <vs-th>No</vs-th>
                <vs-th class="text-left">Camera Name</vs-th>
                <vs-th class="text-left">Camera ID</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">
                    {{ indextr + 1 }}
                </vs-td>

                <vs-td class="text-left" :data="tr.name">
                    ({{ tr.name }})
                </vs-td>

                <vs-td class="text-left" :data="tr.camId">
                    {{ tr.camId }}
                </vs-td>
                </vs-tr>
            </template>
        </vs-table> -->
    </vx-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import api from "@/api";

import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS

export default {
  data() {
    return {
      gridApi: null,
      lists: [],
      isEdit: false,
      defaultColDef: {
        //flex:5,
        //filter: true,
        //sortable: true,
        resizable: true,
      },
      columnDefs: [
        {
          headerName: 'No',
          field: 'no',
          flex:1
        },
        {
          headerName: 'Camera Name',
          field: 'name',
          flex:2
        },
        {
          headerName: 'Camera ID',
          field: 'camId',
          flex:5
        }
      ],
    };
  },
  computed: {
    currentSiteForm() {
        return this.$store.state.currentSiteForm
    },
  },
  components: {
    AgGridVue
  },
  mounted() {
    this.isEdit = this.currentSiteForm.id != undefined && this.currentSiteForm.id != 0

    if(this.isEdit) {
      this.refreshCameras()
    } else {
      this.importCameras()
    }
  },
  methods: {
    onGridReady(params) {
        this.gridApi = params.api;
    },
    saveForm() {

        this.$vs.loading()
        api.saveSite(this.currentSiteForm, this.isEdit)
        .then((result) => result.data)
        .then((data) => {
            this.$vs.loading.close()
            if(!data.status) {
              this.$vs.notify({
                  title:'Error',
                  text: data.message,
                  color:'danger',
                  position:'bottom-center'
              })
            } else {
            this.$vs.notify({
                title:'Success',
                text:'Success save data',
                color:'success',
                position:'bottom-center'
            })
            setTimeout(() => {
                this.$router.push({name:'org_management_sites'})
            },500)
            }
        })
        .catch((e) => {
            console.log(e)
            this.$vs.loading.close()
        });
    },
    importCameras() {
      this.$vs.loading();
      api
        .importCamera({
          ipAddress: `${this.currentSiteForm.ipAddress}`,
          username: this.currentSiteForm.username,
          password: this.currentSiteForm.password,
        })
        .then((result) => result.data)
        .then((data) => {
          if (data.status) {
            this.lists = data.data;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    },
    refreshCameras() {
      this.$vs.loading();
      api
        .refreshCameras({
          siteId: this.currentSiteForm.id,
        })
        .then((result) => result.data)
        .then((data) => {
          if (data.status) {
            this.lists = data.data;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.log(e);
          this.$vs.loading.close();
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 0 5px;
}
.text-center:deep(.vs-table-text) {
  justify-content: center;
}
.text-right:deep(.vs-table-text) {
  justify-content: flex-end;
}
</style>
